<div>
  <mat-form-field class="chips-input-form-field">
    <mat-label>{{label}}</mat-label>
    <mat-chip-list #chipList  [required]="required" [formControl]="arrayControl">
      <mat-chip *ngFor="let item of arrayControl.value" [selectable]="true"
                [removable]="true" (removed)="remove(item)">
        <span *ngIf="pipe">
          {{item | dynamicPipe: pipe:[]}}
        </span>
        <span *ngIf="!pipe">
          {{item}}
        </span>
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip>
      <input placeholder="{{placeholder}}"
             [matChipInputFor]="chipList"
             [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
             [matChipInputAddOnBlur]="true"
             (matChipInputTokenEnd)="add($event)">
    </mat-chip-list>
    <mat-error *ngIf="arrayControl.hasError('required')">Musisz uzupełnić to pole</mat-error>
    <mat-error *ngIf="arrayControl.hasError('backendError')">{{arrayControl.getError('backendError')}}</mat-error>
  </mat-form-field>

</div>
